import { useState } from "react";

interface ImageThumbnail {
  description: string;
  image: string;
}

interface ImageGalleryProps {
  images: ImageThumbnail[];
}

const ImageGalleryComponent: React.FC<ImageGalleryProps> = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState<ImageThumbnail>(images[0]);

  return (
    <div className="flex flex-col md:flex-row gap-4 w-full items-center">
      {/* Main Image (Left Side) */}
      <div className="w-full md:w-3/4 lg:h-96 md:h-[400px] bg-gray-100 rounded-sm overflow-hidden relative">
        <img
          src={selectedImage?.image}
          alt="Main gallery view"
          loading="lazy"
          className="w-full h-full object-cover object-center"
        />
        <p className="absolute bottom-0 right-0 px-4 py-3 text-white Blinker-Regular text-lg bg-black bg-opacity-50 w-full">
          {selectedImage.description}
        </p>
      </div>

      {/* Thumbnails (Right Side) */}
      <div className="w-full md:w-1/4 flex md:flex-col gap-3 overflow-y-auto p-2">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(image)}
            className={`lg:w-full  lg:h-28 h-16 flex-shrink-0 rounded-md overflow-hidden transition-all duration-300 ${
              selectedImage === image
                ? "ring-2 ring-green-500 rounded-md"
                : "opacity-50 hover:opacity-50"
            }`}
          >
            <img
              src={image.image}
              loading="lazy"
              alt={`Thumbnail ${index + 1}`}
              className="w-full h-full object-cover object-center"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ImageGalleryComponent;
